// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr from "./Order_Detail_Old_Vehicle_Edits_Form.bs.js";

function voActionsStatesEditable(order) {
  var reprStatesEditable = Belt_List.length(Belt_List.keep(Belt_List.keepMap(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                      return Belt_Option.getWithDefault(x.actionType, "") === "REPR";
                    })), (function (x) {
                  return x.resultActionStatus;
                })), (function (x) {
              if (x === /* PAID */4 || x === /* PREINVOICED */5) {
                return true;
              } else {
                return x === /* NOBONUS */3;
              }
            }))) === 0;
  var match = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
  var nonfleetVOActionStatesEditable = !(match > 15 || match < 1) && match !== 11 ? Belt_List.length(Belt_List.keep(Belt_List.keepMap(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                        return Belt_Option.getWithDefault(x.actionWithUsedCar, false);
                      })), (function (x) {
                    return x.resultActionStatus;
                  })), (function (x) {
                if (x === /* PAID */4 || x === /* PREINVOICED */5) {
                  return true;
                } else {
                  return x === /* NOBONUS */3;
                }
              }))) === 0 : true;
  if (reprStatesEditable) {
    return nonfleetVOActionStatesEditable;
  } else {
    return false;
  }
}

function getInitialInput(newestUsedCarValues) {
  return {
          value: Belt_Option.mapWithDefault(newestUsedCarValues.orderRealTradeAmount, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.value, (function (x) {
                  return String(x);
                })),
          estimatedValue: Belt_Option.mapWithDefault(newestUsedCarValues.orderEstimatedTradeAmount, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.estimatedValue, (function (x) {
                  return String(x);
                })),
          endOfLife: Belt_Option.mapWithDefault(newestUsedCarValues.orderScrapyardIndicator, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.endOfLife, (function (x) {
                  if (x) {
                    return "true";
                  } else {
                    return "false";
                  }
                })),
          brandUsedCar: Belt_Option.getWithDefault(newestUsedCarValues.orderUcBrand, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.brandUsedCar),
          modelUsedCar: Belt_Option.getWithDefault(newestUsedCarValues.orderUcModel, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.modelUsedCar),
          versionUsedCar: Belt_Option.getWithDefault(newestUsedCarValues.orderUcVersion, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.versionUsedCar),
          registrationNumberUsedCar: Belt_Option.getWithDefault(newestUsedCarValues.orderUcRegistrationId, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.registrationNumberUsedCar),
          vinUsedCar: Belt_Option.getWithDefault(newestUsedCarValues.orderUcVin, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.vinUsedCar),
          firstReleaseDateCar: Belt_Option.mapWithDefault(newestUsedCarValues.orderUCFirstReleaseDate, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.firstReleaseDateCar, (function (x) {
                  return Caml_option.some(x);
                })),
          registrationDateUsedCar: Belt_Option.mapWithDefault(newestUsedCarValues.orderUCLastRegistrationDate, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.registrationDateUsedCar, (function (x) {
                  return Caml_option.some(x);
                })),
          policeNumber: Belt_Option.getWithDefault(newestUsedCarValues.ucPoliceNumber, Order_Detail_Old_Vehicle_Edits_Form$DvmAdminFrontendFr.initialState.policeNumber)
        };
}

function numberValuesChanged(newestUsedCarValues, value, estimatedValue) {
  var origInput = getInitialInput(newestUsedCarValues);
  var match = Belt_Float.fromString(origInput.value);
  var valueChanged = value !== undefined ? (
      match !== undefined ? value !== match : true
    ) : false;
  var match$1 = Belt_Float.fromString(origInput.estimatedValue);
  var estimatedValueChanged = estimatedValue !== undefined ? (
      match$1 !== undefined ? estimatedValue !== match$1 : true
    ) : false;
  if (valueChanged) {
    return true;
  } else {
    return estimatedValueChanged;
  }
}

var Form;

export {
  Form ,
  voActionsStatesEditable ,
  getInitialInput ,
  numberValuesChanged ,
}
/* Order_Detail_Old_Vehicle_Edits_Form-DvmAdminFrontendFr Not a pure module */
